import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Mail } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-900 text-white border-t border-slate-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/assets/images/branding/logo.png" 
                alt="Logo" 
                className="h-10 w-auto"
                onError={(e) => {
                  // Fallback to icon if logo not found
                  e.currentTarget.style.display = 'none';
                  const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                  if (nextElement) nextElement.style.display = 'flex';
                }}
              />
              <div className="hidden items-center space-x-2">
                <div className="relative">
                  <Zap className="h-8 w-8 text-blue-400" />
                  <div className="absolute inset-0 h-8 w-8 text-blue-400 animate-pulse"></div>
                </div>
                <span className="text-xl font-bold bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
                  Your Brand
                </span>
              </div>
            </div>
            <p className="text-slate-300 mb-6 max-w-md">
              Launch your own branded business management platform with our comprehensive white-label solution. 
              Complete ownership, no ongoing fees, unlimited potential.
            </p>
            <div className="flex space-x-4">
              <div className="flex items-center space-x-2 text-slate-300">
                <Mail className="h-4 w-4 text-blue-400" />
                <span>contact@yourdomain.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-blue-400">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/features" className="text-slate-300 hover:text-blue-300 transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="text-slate-300 hover:text-blue-300 transition-colors">Pricing</Link></li>
              <li><Link to="/demo" className="text-slate-300 hover:text-blue-300 transition-colors">Live Demo</Link></li>
              <li><Link to="/industries" className="text-slate-300 hover:text-blue-300 transition-colors">Industries</Link></li>
              <li><Link to="/success-stories" className="text-slate-300 hover:text-blue-300 transition-colors">Success Stories</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-blue-400">Support</h3>
            <ul className="space-y-2">
              <li><Link to="/support" className="text-slate-300 hover:text-blue-300 transition-colors">Documentation</Link></li>
              <li><Link to="/support" className="text-slate-300 hover:text-blue-300 transition-colors">Help Center</Link></li>
              <li><Link to="/support" className="text-slate-300 hover:text-blue-300 transition-colors">Contact Support</Link></li>
              <li><a href="#" className="text-slate-300 hover:text-blue-300 transition-colors">Schedule Demo</a></li>
              <li><a href="#" className="text-slate-300 hover:text-blue-300 transition-colors">FAQ</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700/50 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 text-sm">
              &copy; 2024 Your Company. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-slate-400 hover:text-blue-300 text-sm transition-colors">Privacy Policy</a>
              <a href="#" className="text-slate-400 hover:text-blue-300 text-sm transition-colors">Terms of Service</a>
              <a href="#" className="text-slate-400 hover:text-blue-300 text-sm transition-colors">License Agreement</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
